
import { FaFacebook, FaInstagram, FaWhatsapp, FaLinkedin } from "react-icons/fa";

const Socialmedia = () => {
  return (
    <footer>
      <div className="social-icons">
        {[
          { icon: <FaFacebook />, link: "https://www.facebook.com" },
          { icon: <FaInstagram />, link: "https://www.instagram.com" },
          { icon: <FaWhatsapp />, link: "https://wa.me/919876543210" },
          { icon: <FaLinkedin />, link: "https://www.linkedin.com" },
        ].map((item, idx) => (
          <a key={idx} href={item.link} className="social-link" target="_blank" rel="noopener noreferrer">
            {item.icon}
          </a>
        ))}
      </div>
    </footer>
  );
};

export default Socialmedia;
